import {
  AfterContentChecked,
  AfterContentInit,
  AfterViewChecked,
  AfterViewInit,
  Component,
  Inject,
  OnInit,
  Renderer2
} from '@angular/core';
import {MAT_SNACK_BAR_DATA, MatSnackBarRef} from '@angular/material';

@Component({
  selector: 'app-image-viewer',
  template: `
    <div align="center" class="col_yellow">
      <button aria-label="Close" class="close opacity_1_imp" type="button">
        <span aria-hidden="true" class="col_yellow"
              (click)="snackBarRef.dismiss()">×</span>
      </button>
    </div>
    <div class="row image_viewer_row">
      <div class="col-xs-12 col-sm-12 col-lg-12">
        <img [src]="imageSrc" class="width-100-per height-100-per">
      </div>
    </div>
  `
})
export class ImageViewerComponent implements AfterViewInit {

  constructor(public snackBarRef: MatSnackBarRef<ImageViewerComponent>, private renderer: Renderer2,
              @Inject(MAT_SNACK_BAR_DATA) public imageSrc: string | any) {
  }

  ngAfterViewInit(): void {
    /*setTimeout( () => {
      let snackEl = document.getElementsByTagName('body').item(0);
      this.renderer.listen(snackEl, 'click', ()=>this.snackBarRef.dismiss());
    }, 500);*/
  }
}
